import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { UserService } from 'app/shared/services/user/user.service';
import { AvailableLanguages } from '../../../../config/language-config';
import { AppState } from '../../../app.state';
import { Customer } from '../../models/customer/customer.model';
import { CustomerService } from '../../services/customer/customer.service';
import { User } from '../../services/user/models/user.model';

@Component({
    selector: 'upsc-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    @Input() isMenuOpened = false;
    @Output() sideNavToggled: EventEmitter<boolean> = new EventEmitter<boolean>();

    public user: User;
    public customer: Customer;
    public availableLanguages = AvailableLanguages.filter(lang => lang.isActive);
    public currentLanguage = 'en';

    public constructor(private storage: StorageMap,
                       private readonly userService: UserService,
                       private readonly customerService: CustomerService,
                       public readonly appState: AppState,
    ) {
        this.user = this.appState.user$();
        this.customer = this.appState.customer$();
        this.currentLanguage = sessionStorage.getItem('lang') || 'en';
        this.storage.get('lang').subscribe((lang: string) => {
            this.currentLanguage = lang;
        });
    }

    public ngOnInit() {
        this.removeDuplicateEn();
    }

    public toggleSideNav(event) {
        event.preventDefault();

        this.sideNavToggled.emit(true);
    }

    private removeDuplicateEn() {
        const customerLanguage = this.customerService.getCustomerLanguage(this.customer);
        const removeLang = customerLanguage.toLowerCase() === 'en-gb' ? 'en' : 'en-gb';
        this.availableLanguages = this.availableLanguages.filter(item => item.code !== removeLang);
    }
}
